module.exports = __webpack_public_path__ + "img/12.776636d0.jpg";